// @ts-ignore
import axios from 'axios';
import { encodeBody, 
// @ts-ignore
encodeQueryParams, transformResponse, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@editar-pdf/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const googleAuth = async (parameters, cancelToken) => {
    if (parameters.code === undefined) {
        throw new Error('Missing required parameter: code');
    }
    const path = '/api/auth/gc';
    const query = {
        code: parameters.code,
    };
    return axios({
        method: 'GET',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'text/plain',
        },
    });
};
export const createUserAndLogin = async (form, cancelToken) => {
    if (form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/users';
    return axios({
        method: 'POST',
        url: path,
        data: encodeBody(form),
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};
export const getCurrentUser = async (cancelToken) => {
    const path = '/api/users/me';
    return axios({
        method: 'GET',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const updateCurrentUser = async (form, cancelToken) => {
    if (form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/users/me';
    return axios({
        method: 'PUT',
        url: path,
        data: encodeBody(form),
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};
export const logUserEvent = async (form, parameters, cancelToken) => {
    if (form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (parameters.logType === undefined) {
        throw new Error('Missing required parameter: logType');
    }
    if (parameters.eventType === undefined) {
        throw new Error('Missing required parameter: eventType');
    }
    const path = '/api/users/log-event';
    const query = {
        logType: parameters.logType,
        eventType: parameters.eventType,
        referer: parameters.referer,
        page: parameters.page,
    };
    return axios({
        method: 'POST',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: encodeBody(form),
        cancelToken,
        transformResponse,
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
export const requestRestoreUserPassword = async (parameters, cancelToken) => {
    if (parameters.email === undefined) {
        throw new Error('Missing required parameter: email');
    }
    const path = '/api/users/restore-password/reuqest';
    const query = {
        email: parameters.email,
    };
    return axios({
        method: 'PUT',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
    });
};
export const getUserByVerificationCode = async (parameters, cancelToken) => {
    if (parameters.verificationCode === undefined) {
        throw new Error('Missing required parameter: verificationCode');
    }
    const path = '/api/users/restore-password/by-verification-code';
    const query = {
        verificationCode: parameters.verificationCode,
    };
    return axios({
        method: 'GET',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const restoreUserPasswordAndLogin = async (form, parameters, cancelToken) => {
    if (form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (parameters.verificationCode === undefined) {
        throw new Error('Missing required parameter: verificationCode');
    }
    const path = '/api/users/restore-password';
    const query = {
        verificationCode: parameters.verificationCode,
    };
    return axios({
        method: 'PUT',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: encodeBody(form),
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};
export const generateToken = async (form, cancelToken) => {
    if (form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/token';
    return axios({
        method: 'POST',
        url: path,
        data: encodeBody(form),
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};
export const getStripePublicKey = async (cancelToken) => {
    const path = '/api/stripe-pk';
    return axios({
        method: 'GET',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'text/plain',
        },
    });
};
export const getPaddleClientSideToken = async (cancelToken) => {
    const path = '/api/paddle-pk';
    return axios({
        method: 'GET',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'text/plain',
        },
    });
};
export const getFonts = async (cancelToken) => {
    const path = '/api/fonts';
    return axios({
        method: 'GET',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const matchFonts = async (parameters, cancelToken) => {
    if (parameters.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    const path = '/api/fonts/matches/{fileId}'.replace('{fileId}', parameters.fileId?.toString());
    return axios({
        method: 'GET',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const createSetupIntent = async (cancelToken) => {
    const path = '/api/credit-cards/setup';
    return axios({
        method: 'POST',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'text/plain',
        },
    });
};
export const getCreditCards = async (cancelToken) => {
    const path = '/api/credit-cards';
    return axios({
        method: 'GET',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const deleteCreditCard = async (parameters, cancelToken) => {
    if (parameters.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/credit-cards/{id}'.replace('{id}', parameters.id?.toString());
    return axios({
        method: 'DELETE',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
    });
};
export const setDefaultCreditCard = async (parameters, cancelToken) => {
    if (parameters.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/credit-cards/{id}/set-default'.replace('{id}', parameters.id?.toString());
    return axios({
        method: 'PUT',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const getSubscriptionPlans = async (cancelToken) => {
    const path = '/api/subscriptions';
    return axios({
        method: 'GET',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const updateSubscriptionPlan = async (parameters, cancelToken) => {
    if (parameters.subscriptionType === undefined) {
        throw new Error('Missing required parameter: subscriptionType');
    }
    const path = '/api/subscriptions/{subscriptionType}'.replace('{subscriptionType}', parameters.subscriptionType?.toString());
    return axios({
        method: 'PUT',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const stripeWebhookEvent = async (event, cancelToken) => {
    if (event === undefined) {
        throw new Error('Missing required body: event');
    }
    const path = '/api/subscriptions/webhook/stripe';
    return axios({
        method: 'POST',
        url: path,
        data: encodeBody(event),
        cancelToken,
        transformResponse,
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
export const getPayments = async (parameters, cancelToken) => {
    const path = '/api/payments';
    const query = {
        page: parameters.page,
        size: parameters.size,
    };
    return axios({
        method: 'GET',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const processPayment = async (parameters, cancelToken) => {
    if (parameters.paymentMethodCode === undefined) {
        throw new Error('Missing required parameter: paymentMethodCode');
    }
    if (parameters.subscriptionType === undefined) {
        throw new Error('Missing required parameter: subscriptionType');
    }
    const path = '/api/payments';
    const query = {
        paymentMethodCode: parameters.paymentMethodCode,
        subscriptionType: parameters.subscriptionType,
    };
    return axios({
        method: 'POST',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const getPaymentProvider = async (parameters, cancelToken) => {
    const path = '/api/payments/provider';
    const query = {
        debugIp: parameters.debugIp,
        debugCountry: parameters.debugCountry,
    };
    return axios({
        method: 'GET',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const getPaymentLink = async (parameters, cancelToken) => {
    if (parameters.subscriptionType === undefined) {
        throw new Error('Missing required parameter: subscriptionType');
    }
    const path = '/api/payments/link';
    const query = {
        subscriptionType: parameters.subscriptionType,
    };
    return axios({
        method: 'GET',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const getPaddlePriceId = async (parameters, cancelToken) => {
    if (parameters.subscriptionType === undefined) {
        throw new Error('Missing required parameter: subscriptionType');
    }
    const path = '/api/payments/price-id';
    const query = {
        subscriptionType: parameters.subscriptionType,
    };
    return axios({
        method: 'GET',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const confirmPaymentIntent = async (parameters, cancelToken) => {
    if (parameters.paymentIntentId === undefined) {
        throw new Error('Missing required parameter: paymentIntentId');
    }
    if (parameters.subscriptionType === undefined) {
        throw new Error('Missing required parameter: subscriptionType');
    }
    const path = '/api/payments/confirm-intent';
    const query = {
        paymentIntentId: parameters.paymentIntentId,
        subscriptionType: parameters.subscriptionType,
    };
    return axios({
        method: 'PUT',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
    });
};
export const confirmDodoPaymentIntent = async (parameters, cancelToken) => {
    if (parameters.subscriptionId === undefined) {
        throw new Error('Missing required parameter: subscriptionId');
    }
    if (parameters.subscriptionType === undefined) {
        throw new Error('Missing required parameter: subscriptionType');
    }
    const path = '/api/payments/confirm-intent/dodo-payments';
    const query = {
        subscriptionId: parameters.subscriptionId,
        subscriptionType: parameters.subscriptionType,
    };
    return axios({
        method: 'PUT',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
    });
};
export const confirmPaddlePaymentIntent = async (parameters, cancelToken) => {
    if (parameters.customerId === undefined) {
        throw new Error('Missing required parameter: customerId');
    }
    if (parameters.subscriptionType === undefined) {
        throw new Error('Missing required parameter: subscriptionType');
    }
    const path = '/api/payments/confirm-intent/paddle';
    const query = {
        customerId: parameters.customerId,
        subscriptionType: parameters.subscriptionType,
    };
    return axios({
        method: 'PUT',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
    });
};
export const getFilesMeta = async (parameters, cancelToken) => {
    const path = '/api/files';
    const query = {
        page: parameters.page,
        limit: parameters.limit,
        order: parameters.order,
        sort: parameters.sort,
    };
    return axios({
        method: 'GET',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const deleteFile = async (parameters, cancelToken) => {
    if (parameters.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    const path = '/api/files/{fileId}'.replace('{fileId}', parameters.fileId?.toString());
    return axios({
        method: 'DELETE',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const markSaved = async (parameters, cancelToken) => {
    if (parameters.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    if (parameters.saved === undefined) {
        throw new Error('Missing required parameter: saved');
    }
    const path = '/api/files/{fileId}/mark-saved'.replace('{fileId}', parameters.fileId?.toString());
    const query = {
        saved: parameters.saved,
    };
    return axios({
        method: 'PUT',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const uploadFile = async (formData, onUploadProgress, cancelToken) => {
    const path = '/api/files/upload';
    return axios({
        method: 'POST',
        url: path,
        data: formData,
        onUploadProgress,
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const uploadFileAsset = async (formData, parameters, onUploadProgress, cancelToken) => {
    if (parameters.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/assets/upload';
    const query = {
        type: parameters.type,
    };
    return axios({
        method: 'POST',
        url: `${path}${encodeQueryParams(query, { arrayFormat: 'comma' })}`,
        data: formData,
        onUploadProgress,
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const processPdf = async (context, parameters, cancelToken) => {
    if (context === undefined) {
        throw new Error('Missing required body: context');
    }
    if (parameters.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/process/{id}/new'.replace('{id}', parameters.id?.toString());
    return axios({
        method: 'POST',
        url: path,
        data: encodeBody(context),
        cancelToken,
        transformResponse,
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
export const getSavedPdf = async (parameters, cancelToken) => {
    if (parameters.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/process/{id}/saved'.replace('{id}', parameters.id?.toString());
    return axios({
        method: 'GET',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const downloadPdf = async (parameters, cancelToken) => {
    if (parameters.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/download/{id}'.replace('{id}', parameters.id?.toString());
    return axios({
        method: 'GET',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const convertPdfToWord = async (parameters, cancelToken) => {
    if (parameters.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/convert/{id}/pdf-to-word'.replace('{id}', parameters.id?.toString());
    return axios({
        method: 'GET',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export const getAsset = async (parameters, cancelToken) => {
    if (parameters.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/assets/{id}'.replace('{id}', parameters.id?.toString());
    return axios({
        method: 'GET',
        url: path,
        data: {},
        cancelToken,
        transformResponse,
        headers: {
            Accept: 'application/json',
        },
    });
};
export * from './types';
//# sourceMappingURL=index.js.map